import { render, staticRenderFns } from "./addcin.vue?vue&type=template&id=35c30e58&scoped=true&"
import script from "./addcin.vue?vue&type=script&lang=js&"
export * from "./addcin.vue?vue&type=script&lang=js&"
import style0 from "./addcin.vue?vue&type=style&index=0&id=35c30e58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c30e58",
  null
  
)

export default component.exports